import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { bundlesViewColumns, mapBundlesViewQuery } from "./BundlesView.default";
import { getBundles } from "../../repository/data.repository";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";
import { createGridRequest } from "../../hooks/useGridRequest";

export interface BundlesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function BundlesView(props: BundlesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={bundlesViewColumns}
      mapQuery={mapBundlesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getBundles, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              {
                type: "textbox",
                name: "createdByUserUserName",
                label: "Created by",
              },
              { type: "rangetimepicker", name: "createdOn", label: "Created On" },
            ],
          },
        ],
      }}
      actions={(record) => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Bundles", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Bundles", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default BundlesView;
